'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeywordFieldContainer = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _user = require('redux/saga/selectors/user');

var _bound = require('redux/saga/entities/bound');

var _deep = require('helpers/deep');

var _SearchBox = require('./SearchBox.constants');

var _KeywordField = require('./KeywordField');

var _SearchBox2 = require('./SearchBox.saga');

var _SearchBox3 = require('./SearchBox.reducer');

var mapDispatchToProps = {
  onFieldFocus: _SearchBox3.setOpenPanel.bind(null, _SearchBox.PANEL_NAMES.keyword),
  onSelect: _SearchBox2.searchPanelItemSelected.bind(null, _SearchBox.PANEL_NAMES.keyword),
  onRemoveItem: _SearchBox2.removeSearchboxHistoryItem.bind(null, _SearchBox.PANEL_NAMES.keyword),
  onClose: _SearchBox3.closeOpenPanel,
  onClear: _SearchBox3.clearKeywordField,
  onValueChange: _SearchBox3.setKeywordFieldValue
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var searchBox = (0, _SearchBox3.selectSearchBoxState)(state);
  var inputValue = searchBox.keywordFieldValue;

  var venues = void 0;
  var activities = void 0;
  var history = [];
  var isLoading = void 0;

  if (inputValue) {
    var lastKeyToHaveLoaded = searchBox.keywordKey;

    isLoading = lastKeyToHaveLoaded !== inputValue;
    var results = _bound.keywordAutocomplete.data(state, lastKeyToHaveLoaded) || [];
    venues = (0, _deep.deepExtract)('entries', results.find(function (_ref) {
      var type = _ref.type;
      return type === 'venues';
    }), []);
    activities = (0, _deep.deepExtract)('entries', results.find(function (_ref2) {
      var type = _ref2.type;
      return type === 'activities';
    }), []);
  } else {
    isLoading = _bound.searchLayoutByName.loading(state, _SearchBox.HEADER_LAYOUT);
    var headerData = isLoading ? {} : _bound.searchLayoutByName.data(state, _SearchBox.HEADER_LAYOUT);
    venues = (0, _deep.deepExtract)('popular_studios.data', headerData, []);
    activities = (0, _deep.deepExtract)('popular_activities.data', headerData, []);
    history = (0, _deep.deepExtract)('keyword_history.data', headerData, []);
  }

  return {
    isLoading: isLoading,
    isLoggedIn: (0, _user.isLoggedIn)(state),
    hasResults: [venues, activities, history].some(function (arr) {
      return arr.length;
    }),
    blurredValue: searchBox.keywordDisplayValue,
    hasQuery: inputValue.length > 0,
    venues: venues.slice(0, _SearchBox.NUM_VENUES_IN_PANEL),
    history: history.slice(0, _SearchBox.NUM_HISTORY_IN_PANEL),
    activities: activities.slice(0, _SearchBox.NUM_ACTIVITIES_IN_PANEL),
    inputValue: inputValue
  };
};

var KeywordFieldContainer = exports.KeywordFieldContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_KeywordField.KeywordField);